(function () {
'use strict';
var doc = document;
var root = doc.documentElement;
var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var designMode = !!(window.Shopify && window.Shopify.designMode);
var squeeze = window.matchMedia('(min-width: 990px)');
root.classList.add('nbp-js');
window.__nbpReady = true;
function scrollEl() {
if (squeeze.matches) return doc.querySelector('.page-wrapper') || doc.scrollingElement || root;
return doc.scrollingElement || root;
}
function scrollTarget() {
return squeeze.matches ? doc.querySelector('.page-wrapper') || window : window;
}
function onScroll(cb) {
var ticking = false;
var handler = function () {
if (ticking) return;
ticking = true;
requestAnimationFrame(function () { cb(scrollEl().scrollTop); ticking = false; });
};
var current = scrollTarget();
current.addEventListener('scroll', handler, { passive: true });
squeeze.addEventListener('change', function () {
current.removeEventListener('scroll', handler);
current = scrollTarget();
current.addEventListener('scroll', handler, { passive: true });
handler();
});
handler();
}
var revealObserver = null;
var pending = new Set();
var sweepBound = false;
function initReveal(scope) {
var items = (scope || doc).querySelectorAll('[data-nbp-reveal]:not(.is-inview)');
if (!items.length) return;
(scope || doc).querySelectorAll('[data-nbp-stagger]').forEach(function (group) {
var step = parseFloat(group.getAttribute('data-nbp-stagger')) || 0.08;
var kids = group.querySelectorAll(':scope > [data-nbp-reveal]');
kids.forEach(function (el, i) { el.style.setProperty('--nbp-delay', (i * step).toFixed(2) + 's'); });
});
if (reduceMotion || designMode || !('IntersectionObserver' in window)) {
items.forEach(function (el) { el.classList.add('is-inview'); });
return;
}
if (!revealObserver) {
revealObserver = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) {
entry.target.classList.add('is-inview');
revealObserver.unobserve(entry.target);
}
});
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
}
items.forEach(function (el) { revealObserver.observe(el); pending.add(el); });
if (!sweepBound) {
sweepBound = true;
onScroll(function () {
if (!pending.size) return;
var vh = window.innerHeight;
pending.forEach(function (el) {
if (el.classList.contains('is-inview')) { pending.delete(el); return; }
var r = el.getBoundingClientRect();
if (r.top < vh * 0.92 && r.left < window.innerWidth && r.right > 0) {
el.classList.add('is-inview');
revealObserver.unobserve(el);
pending.delete(el);
}
});
});
}
}
function initCarousels(scope) {
(scope || doc).querySelectorAll('[data-nbp-carousel]:not([data-nbp-ready])').forEach(function (carousel) {
carousel.setAttribute('data-nbp-ready', '');
var track = carousel.querySelector('[data-nbp-track]');
if (!track) return;
var prev = carousel.querySelectorAll('[data-nbp-prev]');
var next = carousel.querySelectorAll('[data-nbp-next]');
var fill = carousel.querySelector('[data-nbp-progress]');
function step() {
var item = track.firstElementChild;
if (!item) return track.clientWidth;
var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
return item.getBoundingClientRect().width + gap;
}
function update() {
var max = track.scrollWidth - track.clientWidth;
var x = track.scrollLeft;
prev.forEach(function (b) { b.disabled = x <= 2; });
next.forEach(function (b) { b.disabled = x >= max - 2; });
carousel.classList.toggle('is-static', max <= 2);
if (fill) {
var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
var w = Math.max(ratio * 100, 8);
var pos = max > 0 ? (x / max) * ((100 - w) / w) * 100 : 0;
fill.style.setProperty('--nbp-progress-w', w + '%');
fill.style.setProperty('--nbp-progress-x', pos + '%');
}
}
prev.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); }); });
next.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); }); });
track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
window.addEventListener('resize', update);
var down = false, startX = 0, startLeft = 0, moved = false;
track.addEventListener('pointerdown', function (e) {
if (e.pointerType !== 'mouse' || e.button !== 0) return;
down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
});
window.addEventListener('pointermove', function (e) {
if (!down) return;
var dx = e.clientX - startX;
if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); }
if (moved) track.scrollLeft = startLeft - dx;
});
window.addEventListener('pointerup', function () {
if (!down) return;
down = false;
if (moved) {
track.classList.remove('is-dragging');
var s = step();
track.scrollTo({ left: Math.round(track.scrollLeft / s) * s, behavior: 'smooth' });
track.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
}
});
update();
});
}
function initSliders(scope) {
(scope || doc).querySelectorAll('[data-nbp-slider]:not([data-nbp-ready])').forEach(function (slider) {
slider.setAttribute('data-nbp-ready', '');
var slides = slider.querySelectorAll('[data-nbp-slide]');
var dots = slider.querySelectorAll('[data-nbp-dot]');
if (slides.length < 2) { slides[0] && slides[0].classList.add('is-active'); return; }
var index = 0;
var delay = (parseFloat(slider.getAttribute('data-autoplay')) || 0) * 1000;
var timer = null;
function go(i) {
slides[index].classList.remove('is-active');
slides[index].setAttribute('aria-hidden', 'true');
dots[index] && dots[index].setAttribute('aria-current', 'false');
index = (i + slides.length) % slides.length;
slides[index].classList.add('is-active');
slides[index].removeAttribute('aria-hidden');
dots[index] && dots[index].setAttribute('aria-current', 'true');
}
function play() { if (delay && !reduceMotion && !designMode) { stop(); timer = setInterval(function () { go(index + 1); }, delay); } }
function stop() { if (timer) clearInterval(timer); timer = null; }
dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); play(); }); });
var p = slider.querySelector('[data-nbp-slide-prev]');
var n = slider.querySelector('[data-nbp-slide-next]');
p && p.addEventListener('click', function () { go(index - 1); play(); });
n && n.addEventListener('click', function () { go(index + 1); play(); });
slider.addEventListener('mouseenter', stop);
slider.addEventListener('mouseleave', play);
slider.addEventListener('focusin', stop);
var sx = 0;
slider.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
slider.addEventListener('touchend', function (e) {
var dx = e.changedTouches[0].clientX - sx;
if (Math.abs(dx) > 50) { go(index + (dx < 0 ? 1 : -1)); play(); }
});
doc.addEventListener('visibilitychange', function () { doc.hidden ? stop() : play(); });
slider._nbpGo = function (i) { go(i); stop(); };
play();
});
}
function initHeader(scope) {
var header = (scope || doc).querySelector('[data-nbp-header]');
if (!header || header.hasAttribute('data-nbp-ready')) return;
header.setAttribute('data-nbp-ready', '');
var hideOnScroll = header.getAttribute('data-hide-on-scroll') === 'true';
var last = 0;
function setHeight() {
doc.body.style.setProperty('--header-height', header.offsetHeight + 'px');
doc.body.style.setProperty('--nbp-header-h', header.offsetHeight + 'px');
}
setHeight();
window.addEventListener('resize', setHeight);
onScroll(function (y) {
header.classList.toggle('is-scrolled', y > 40);
if (hideOnScroll && !header.classList.contains('menu-open')) {
header.classList.toggle('is-hidden', y > last && y > 240);
}
last = y;
});
var drawer = header.querySelector('[data-nbp-drawer]');
var openers = header.querySelectorAll('[data-nbp-drawer-open]');
var closers = header.querySelectorAll('[data-nbp-drawer-close]');
function openDrawer() {
if (!drawer) return;
drawer.hidden = false;
requestAnimationFrame(function () { drawer.classList.add('is-open'); });
header.classList.add('menu-open');
root.setAttribute('scroll-lock', '');
openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
var first = drawer.querySelector('a, button, summary');
first && first.focus({ preventScroll: true });
}
function closeDrawer() {
if (!drawer || !drawer.classList.contains('is-open')) return;
drawer.classList.remove('is-open');
header.classList.remove('menu-open');
root.removeAttribute('scroll-lock');
openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
setTimeout(function () { drawer.hidden = true; }, 450);
openers[0] && openers[0].focus({ preventScroll: true });
}
openers.forEach(function (b) { b.addEventListener('click', openDrawer); });
closers.forEach(function (b) { b.addEventListener('click', closeDrawer); });
doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
window.matchMedia('(min-width: 1025px)').addEventListener('change', function (m) { if (m.matches) closeDrawer(); });
header.querySelectorAll('[data-nbp-dropdown]').forEach(function (item) {
var trigger = item.querySelector('[data-nbp-dropdown-trigger]');
var t = null;
function open() { clearTimeout(t); item.classList.add('is-open'); trigger && trigger.setAttribute('aria-expanded', 'true'); }
function close() { t = setTimeout(function () { item.classList.remove('is-open'); trigger && trigger.setAttribute('aria-expanded', 'false'); }, 120); }
item.addEventListener('mouseenter', open);
item.addEventListener('mouseleave', close);
item.addEventListener('focusin', open);
item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { item.classList.remove('is-open'); trigger && trigger.focus(); } });
});
}
function initMarquees(scope) {
(scope || doc).querySelectorAll('[data-nbp-marquee]:not([data-nbp-ready])').forEach(function (m) {
m.setAttribute('data-nbp-ready', '');
var inner = m.querySelector('[data-nbp-marquee-inner]');
if (!inner) return;
var group = inner.firstElementChild;
if (!group) return;
var guard = 0;
while (group.scrollWidth < window.innerWidth && guard < 8) {
Array.prototype.slice.call(group.children).forEach(function (c) { group.appendChild(c.cloneNode(true)); });
guard++;
}
var clone = group.cloneNode(true);
clone.setAttribute('aria-hidden', 'true');
clone.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
inner.appendChild(clone);
m.classList.add('is-running');
});
}
function initAccordions(scope) {
(scope || doc).querySelectorAll('details[data-nbp-accordion]:not([data-nbp-ready])').forEach(function (d) {
d.setAttribute('data-nbp-ready', '');
var summary = d.querySelector('summary');
var body = d.querySelector('[data-nbp-accordion-body]');
if (!summary || !body || reduceMotion) return;
summary.addEventListener('click', function (e) {
e.preventDefault();
if (d.open) {
body.style.height = body.scrollHeight + 'px';
requestAnimationFrame(function () { body.style.height = '0px'; });
d.classList.remove('is-open');
setTimeout(function () { d.open = false; body.style.height = ''; }, 380);
} else {
d.open = true;
d.classList.add('is-open');
body.style.height = '0px';
requestAnimationFrame(function () { body.style.height = body.scrollHeight + 'px'; });
setTimeout(function () { body.style.height = ''; }, 400);
}
});
});
}
function initAll(scope) {
initHeader(scope);
initMarquees(scope);
initSliders(scope);
initCarousels(scope);
initAccordions(scope);
initReveal(scope);
}
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initAll(); });
else initAll();
doc.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
doc.addEventListener('shopify:block:select', function (e) {
var slide = e.target.closest('[data-nbp-slide]');
var slider = e.target.closest('[data-nbp-slider]');
if (slide && slider && slider._nbpGo) {
slider._nbpGo(Array.prototype.indexOf.call(slider.querySelectorAll('[data-nbp-slide]'), slide));
}
});
})();